import React, { useMemo } from 'react';
// components/Common/LoadingSquare.jsx
import "./LoadingSquare.css";
/*
const LoadingSquare = ({ color = "#fff", isLoaded=false }) => {
  return (
    <div
      className={`loading-square ${isLoaded ? "loaded" : ""}`}
      style={{ backgroundColor: color }}
    />
  );
};

export default LoadingSquare;

*/


const LoadingSquare = (color = "#6fec1c", isLoaded=false) => {
  // Génère une valeur aléatoire unique au rendu initial
  const randomScale = useMemo(() => {
    // 0.4 + 0.2 * random → entre 0.4 et 0.6
    return 0.4 + Math.random() * 0.2;
  }, []);

    const randomDelay = useMemo(() => {
    // 0.4 + 0.2 * random → entre 0.4 et 0.6
    return 0.8 + Math.random() * 1.2;
  }, []);





  const animationStyle = {
    //position: 'absolute',
    width: '50%',
    height: '50%',
    pointerEvents: 'none',
    animation: `pulseSquareRandom ${randomDelay}s ease-in-out infinite`,
    // Variables CSS pour le random
    '--random-scale': randomScale,
    backgroundColor:color,
  };

  return (
    <>
      <div className="loading-square" style={animationStyle}  />
      
      {/* Keyframes dynamiques injectés dans le DOM */}
      <style>{`
        @keyframes pulseSquareRandom {
          0% {
            transform: scale(var(--random-scale, 1));
          }
          50% {
            transform: scale(calc(var(--random-scale, 1) * 0.5));
          }
          100% {
            transform: scale(var(--random-scale, 1));
          }
        }
      `}</style>
    </>
  );
};

export default LoadingSquare;